<script>
import MacroCardMini from '@components/macros/macro-card-mini.vue';
import { platelistComputed } from '@src/state/helpers';

export default {
  components: {
    MacroCardMini,
  },
  props: {
    planWeek: {
      type: [Object, Array],
      required: true,
      default: () => {},
    },
    open: {
      type: Boolean,
      required: false,
    },
    isClientView: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      showMacroCards: this.open,
    };
  },
  computed: {
    ...platelistComputed,
    planDays() {
      return (this.planWeek && this.planWeek.planDays) || this.planWeek;
    },
  },
};
</script>

<template>
  <div class="macros-bar-wrapper">
    <div class="macros-bar">
      <span>Macros</span>
      <h5 class="section-title" @click="showMacroCards = !showMacroCards">
        <span v-if="!showMacroCards">Show</span>
        <span v-else>Hide</span>
        <img
          :class="['icon-chevron-down', { up: showMacroCards }]"
          src="@assets/images/icon-chevron-down.svg"
        />
      </h5>
    </div>
    <div :class="['macro-cards', { expanded: showMacroCards }]">
      <MacroCardMini
        v-for="(day, i) in planDays"
        :key="i"
        :day="day"
        :isClientView="isClientView"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.macros-bar-wrapper {
  margin-bottom: 10rem;

  .macros-bar {
    align-items: center;
    background-color: $color-off-white;
    color: black;
    display: flex;
    font-size: 1.4rem;
    font-weight: 900;
    height: 5.1rem;
    justify-content: space-between;
    line-height: 1.9rem;
    padding: 1.6rem 3.4rem 1.6rem 1.8rem;

    .section-title {
      text-transform: capitalize;

      &:hover {
        cursor: pointer;
      }

      .icon-chevron-down {
        margin-left: 1rem;

        &.up {
          transform: rotate(180deg);
        }
      }
    }
  }
}

.macro-cards {
  display: flex;
  height: 0;
  overflow: hidden;
  transition: height $duration-animation-base ease-in-out;

  &.expanded {
    height: 25.55rem;
  }
}
</style>
